import { ModuleFE_MacroTag } from './ModuleFE_MacroTag.js';
export const ModulePackFE_MacroTag = [ModuleFE_MacroTag];
//# sourceMappingURL=module-pack.js.map